import {Injectable} from "@angular/core";

@Injectable()
export class AdditionalPointValidatorService {

    private errors:any={};

    public validate(posForm) {
        this.errors = {};
        let isValid = true;
        if(!this.validateForm(posForm)){
            isValid=false;
        }
        return {valid:isValid, errors:this.errors};
    }

    private validateForm(form) : boolean{
        if(form.valid){
            return true;
        } else {
            this.reportErrors(form);
            return false;
        }
    }

    private reportErrors(form: any) {
        Object.keys(form.controls).forEach((key) => {
            if(!!form.controls[key].errors){
                this.errors[key] = form.controls[key].errors;
            }
        })
    }

    private reportError(key, obj) {
        this.errors[key]=obj;
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/additionalPoint/edit/additional-point-validator.service.ts